import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(defaultCardStyles, {
    titleText: {
        variant: "h2",
        as: "h2",
    },
});
